<template>
  <div
    class="
      fixed
      z-50
      flex
      items-center
      justify-center
      w-screen
      h-screen
      bg-white
      space-x-3
    "
  >
    <div class="w-4 h-4 bg-primary rounded-full animate-bounce"></div>
    <div
      class="animation-delay-75 w-4 h-4 bg-primary rounded-full animate-bounce"
    ></div>
    <div
      class="animation-delay-150 w-4 h-4 bg-primary rounded-full animate-bounce"
    ></div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'dn-loader',
})
export default class Loader extends Vue {}
</script>
